import * as React from 'react';
import { st, classes } from './LegacyCard.st.css';
import {
  TPAComponentsConsumer,
  TPAComponentsContext,
} from '../TPAComponentsConfig';
import { deprecationLog } from '../../common/deprecationLog';
import { LegacyCardDataHooks } from './constant';
import { LegacyCardProps, LegacyCardRatioOptions } from './types';

export class LegacyCard extends React.Component<LegacyCardProps> {
  static contextType = TPAComponentsContext;
  static displayName = 'Card';
  static MIN_WIDTH = 700;
  static MIN_WIDTH_MOBILE = 130;

  static defaultProps = {
    ratio: LegacyCardRatioOptions.RATIO_50_50,
    flippedRatio: false,
    invertInfoPosition: false,
    stacked: false,
  };

  componentDidMount(): void {
    deprecationLog(
      'LegacyCard',
      'The current `LegacyCard` component will be deprecated in the next major version. Please use the `Card` component instead.\nYou can view the new API here: https://wix-wix-ui-tpa.surge.sh/?path=/story/components--card',
    );
  }

  private getRatio() {
    const { mediaAspectRatio, stacked } = this.props;
    if (mediaAspectRatio) {
      return mediaAspectRatio && `${Math.round(100 / mediaAspectRatio)}%`;
    }

    return `${stacked ? 100 : 0}%`;
  }

  render() {
    const {
      info,
      media,
      ratio,
      invertInfoPosition,
      flippedRatio,
      stacked,
      mediaAspectRatio,
      className,
    } = this.props;
    const cardRatio = media ? ratio : LegacyCardRatioOptions.RATIO_100;

    return (
      <TPAComponentsConsumer>
        {({ mobile }) => (
          <div
            className={st(
              classes.root,
              {
                ratio: cardRatio,
                invertInfoPosition,
                flippedRatio,
                stacked,
                mobile,
                mediaAspectRatio: !!mediaAspectRatio || stacked,
              },
              classes.deprecated,
              className,
            )}
            data-hook={this.props['data-hook']}
            data-mobile={mobile}
            data-is-inverted={invertInfoPosition}
            data-is-flipped-ratio={flippedRatio}
            data-ratio={cardRatio}
          >
            {media && ratio !== LegacyCardRatioOptions.RATIO_100 && (
              <div
                className={classes.mediaWrapper}
                style={{ paddingTop: this.getRatio() }}
              >
                <div
                  className={classes.mediaContainer}
                  data-hook={LegacyCardDataHooks.mediaContainer}
                >
                  {media}
                </div>
              </div>
            )}
            {info && (
              <div
                className={classes.infoContainer}
                data-hook={LegacyCardDataHooks.infoContainer}
              >
                {info}
              </div>
            )}
          </div>
        )}
      </TPAComponentsConsumer>
    );
  }
}
